/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalletInnerBoxVo
 */
export interface PalletInnerBoxVo {
    /**
     * 箱子 id
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    boxId?: number;
    /**
     * 箱子唛头号 markNo
     * @type {string}
     * @memberof PalletInnerBoxVo
     */
    markNo?: string;
    /**
     * 箱子重量 kg
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    wtKg?: number;
    /**
     * 箱子 CBM
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    cbm?: number;
    /**
     * 箱子长 cm
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    length?: number;
    /**
     * 箱子宽 cm
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    width?: number;
    /**
     * 箱子高 cm
     * @type {number}
     * @memberof PalletInnerBoxVo
     */
    height?: number;
}

/**
 * Check if a given object implements the PalletInnerBoxVo interface.
 */
export function instanceOfPalletInnerBoxVo(value: object): value is PalletInnerBoxVo {
    return true;
}

export function PalletInnerBoxVoFromJSON(json: any): PalletInnerBoxVo {
    return PalletInnerBoxVoFromJSONTyped(json, false);
}

export function PalletInnerBoxVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalletInnerBoxVo {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
    };
}

export function PalletInnerBoxVoToJSON(json: any): PalletInnerBoxVo {
    return PalletInnerBoxVoToJSONTyped(json, false);
}

export function PalletInnerBoxVoToJSONTyped(value?: PalletInnerBoxVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'markNo': value['markNo'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
    };
}

